module.exports = __webpack_public_path__ + "static/img/6设计师2.10e0c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/6设计师2.png
// module id = 3kCZ
// module chunks = 1